export default __webpack_public_path__ + "static/brush-mobile-aad70e46f6300189f98857eea475833a.png";